import React, { useState } from 'react';
import "./Sec1Home.css"
import HomeImg from '../../Images/zinnov-nasscom-mid-market-global-capability-centers-gccs-2025-banner-new.jpg'
// import Facebook from '../../Images/facebook.png'
// import Twitter from '../../Images/twitter.png'
// import Linkedin from '../../Images/linkedin.png'
import Arrow from '../../Images/Arrow<.png'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

function Sec1Home() {
  // const [isExpanded, setIsExpanded] = useState(false);

  // const toggleExpand = () => {
  //   setIsExpanded(!isExpanded);
  // };

  const handleScroll = () => {
    const target = document.getElementById('image-preview-slider');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleScrollContact = () => {
    const Contact = document.getElementById('ContactForm');
    if (Contact) {
      Contact.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="sec1home-container container">
      <div className="sec1home-content">
      {/*<div className='NewBlog'>
         <img src={Arrow}></img>
          <p>Back to New Blog</p> 
        </div> */}
        <h1 className="sec1home-title">Zinnov-nasscom Mid-Market Global Capability Centers (GCC) Report FY2025</h1>
        <div className='social-links-container'>
            {/* <div className="social-link-icons">
              <a href='https://x.com/zinnov'className='social-links twitter'><img src={Twitter} alt="Twitter" /></a>
              <a href='https://www.linkedin.com/company/zinnov' className='social-links linkedin'><img src={Linkedin} alt="Linkedin" /></a>
              <a href='https://www.facebook.com/ZinnovManagementConsulting' className='social-links facebook'><img src={Facebook} alt="Facebook" /></a>
            </div> */}
            <button className="downloadButton" onClick={handleScroll}>
              View Report
            </button>
        </div>
        
        {/* <div className="sec1home-image-container">
            <img src={HomeImg} alt='Zinnov-nasscom Mid-market GCC Report 2025' className="sec1home-image" preload="auto" />
        </div> */}

        <AudioPlayer
          className='audio'
          showJumpControls={true}
          customAdditionalControls={[]}
          src="https://zinnov.s3.us-east-2.amazonaws.com/polly/zinnov-nasscom-mid-market-global-capability-centers-gccs-2025-report.mp3.d2e56fb6-0e91-4c14-b423-14a87e92fca1.mp3"
          layout="horizontal"
        />

        <h2>GCCs in India</h2>
        <p className="sec1home-paragraph text"><b>Across India’s 1,760+ Global Capability Centers,a quiet but powerful shift is underway. A new cohort - the Mid-market GCCs - is steadily rising, now making up 27% of the entire landscape. </b> </p>
        <p className="sec1home-paragraph text">Today, over <b>480 Mid-market GCCs are now operational across India</b>, employing more than 210,000 professionals. On the surface, it’s an impressive statistic. But dig deeper, and you will understand that the real story is "<i>the velocity."</i> <b>35% of these centers have been established in just the last two years (FY23–25E)</b>. In a world obsessed with speed and scale, this level of momentum from Mid-sized Global Enterprises is a signal worth decoding.</p>

        <div id='grid-sec1'>
          <div id="authors-section">
            <div id="author-details" className='setupGccBlock'>
              {/* <div className='closed'>
                <h5 id="authors-title">Authors</h5>
                <div class='author-icon-block' onClick={toggleExpand}>
                  <span style={{ marginTop: isExpanded ? '-2px' : '0' }}>
                    {isExpanded ? '-' : '+'}
                  </span>
                </div>
              </div>
              {isExpanded && (
                <>
                  <span className="author" id="author-1">
                    <p className="author-name">Achyuta Ghosh</p>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Senior Director and Head - Insights</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>nasscom</p>
                  </span>
                  <span className="author" id="author-2">
                    <a className="author-name" href='https://zinnov.com/nitika-goel/' target='_blank'>Nitika Goel</a>
                    <p className="author-title authortext" style={{ color: '#939393' }}>CMO & Managing Partner</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>Zinnov</p>
                  </span>
                  <span className="author" id="author-3">
                  <a className="author-name" href='https://zinnov.com/namita-adavi/' target='_blank'>Namita Adavi</a>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Partner</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>Zinnov</p>
                  </span>
                  <span className="author" id="author-4">
                    <p className="author-name">Sneha Sharma</p>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Senior Analyst - Insights</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>nasscom</p>
                  </span>
                  <span className="author" id="author-5">
                    <p className="author-name">Animesh Kumar Jain</p>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Project Lead</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>Zinnov</p>
                  </span>
                  <span className="author" id="author-6">
                    <p className="author-name">Varun K R Aithal</p>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Consultant</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>Zinnov</p>
                  </span>
                </>
              )} */}
              <div className='setupGcc' onClick={handleScrollContact}>
                <h3>Looking to set up your future-ready GCC?</h3>
              </div>
            </div>
            
            <div id='tag'>
              <a className='tags' href='https://zinnov.com/offerings/gcc-setup-and-transformation/' target='_blank'>GCC SETUP & TRANSFORMATION</a>
              <a className='tags' href='https://zinnov.com/offerings/globalization-excellence/global-capability-centers-setup/' target='_blank'>GLOBAL CAPABILITY CENTER SETUP</a>
            </div>
          </div>
            
          <p className="sec1home-paragraph text"> These <b>Mid-market GCCs</b> aren’t scaled-down replicas of larger centers. They’re fast, focused, and increasingly central to global strategy—taking on transformation mandates, anchoring product roles, and redefining how and where innovation happens.</p>
        </div>
        {/* <p className="sec1home-paragraph text">Over decades, these GCCs progressed up the value chain from basic business process support to directing global innovation and core operations. Today over 1600 maturing GCCs drive global transformation showcasing India’s immense service delivery capabilities.
        It begs the question – why set up a Global Capability Center in India and what motivates increasing MNCs to join the ranks by adding offshore captive centers in India year on year?</p> */}
      </div>
    </div>
  );
}

export default Sec1Home;
